import React from 'react';
import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import SlideBanner from '@components/common/SlideBanner/SlideBanner';
import NewsNavPromotion from '@components/NewsPromotion/NewsNavPromotion';
import NewsListPromotion from '@components/NewsPromotion/NewsListPromotion';
import {NextSeo} from 'next-seo';
import NewsService from '@services/news.service';
import {generatePromotionListSEO} from '@helper/seo/generators/news';

export default function UuDai(props) {
    const {locale} = useRouter();
    const {seoPage} = props;
    
    return (
        <>
            {seoPage && <NextSeo {...seoPage} />}
            <div>
            <SlideBanner titleBanner={getLocaleContent(locale, 'page.promotion-page.page-title')} />
            <NewsNavPromotion />
            <NewsListPromotion />
        </div>
        </>
    );
}

UuDai.getInitialProps = async (context) => {
    try {
        const ctx = context || {};
        const webUrl = process.env.NEXT_PUBLIC_WEB_URL || process.env.WEB_URL || 'https://tnh.com.vn';
        
        // Fetch data thực tế từ API
        let promotions = [];
        try {
            const newsService = new NewsService(ctx);
            
            // Lấy category ưu đãi
            const categoriesResponse = await newsService.getNewsCategoryList({
                locale: ctx.locale || 'vn'
            });
            
            let categoryList = [];
            if (categoriesResponse) {
                if (Array.isArray(categoriesResponse)) {
                    categoryList = categoriesResponse;
                } else if (categoriesResponse.categoryList && Array.isArray(categoriesResponse.categoryList)) {
                    categoryList = categoriesResponse.categoryList;
                } else if (categoriesResponse.data && Array.isArray(categoriesResponse.data)) {
                    categoryList = categoriesResponse.data;
                }
            }
            
            // Tìm category ưu đãi
            const promotionCategory = categoryList.find(cat => 
                cat.news_category_name?.toLowerCase().includes('ưu đãi') || 
                cat.news_category_name?.toLowerCase().includes('promotion') ||
                cat.news_category_name?.toLowerCase().includes('khuyến mãi')
            );
            
            if (promotionCategory) {
                // Lấy danh sách ưu đãi (lấy khoảng 10-15 items đầu để tạo SEO, không cần hết vì có load more)
                const promotionsResponse = await newsService.getNewsList({
                    locale: ctx.locale || 'vn',
                    pageSize: 15,
                    pageIndex: 1,
                    news_category_id: promotionCategory.news_category_id
                });
                
                // Xử lý response structure
                if (promotionsResponse) {
                    if (Array.isArray(promotionsResponse)) {
                        promotions = promotionsResponse;
                    } else if (promotionsResponse.items && Array.isArray(promotionsResponse.items)) {
                        promotions = promotionsResponse.items;
                    } else if (promotionsResponse.data && Array.isArray(promotionsResponse.data)) {
                        promotions = promotionsResponse.data;
                    } else if (promotionsResponse.newsList && Array.isArray(promotionsResponse.newsList)) {
                        promotions = promotionsResponse.newsList;
                    }
                }
            }
        } catch (err) {
            console.error('Failed to fetch promotions data for SEO:', err);
        }
        
        // Tạo SEO từ data thực tế
        const seoPage = generatePromotionListSEO(promotions, webUrl);
        
        return {seoPage};
    } catch (error) {
        console.error('Failed to fetch SEO for promotion page:', error);
        const webUrl = process.env.NEXT_PUBLIC_WEB_URL || process.env.WEB_URL || 'https://tnh.com.vn';
        // Fallback SEO
        const seoPage = generatePromotionListSEO([], webUrl);
        return {seoPage};
    }
};
